import { useMemo } from 'react';
import { useFormatCurrency } from './useFormatCurrency';
/**
 * Extracts the currency symbol used for the current culture and currency settings.
 *
 * This hook formats a value of 0 using `Intl.NumberFormat` and strips out numeric characters,
 * common punctuation, and whitespace to isolate the currency symbol.
 *
 * Useful for conditionally displaying currency symbols inside or outside of input fields,
 * particularly when the symbol is a single character (e.g. "£") vs. longer codes (e.g. "AED").
 *
 * @returns {string} The currency symbol as a string (e.g. "£", "$", "AED").
 */
export const useCurrencySymbol = () => {
    const formattedZero = useFormatCurrency({ amount: 0 });
    const symbol = useMemo(() => {
        // Remove numbers, dots, commas, spaces — leave only the currency symbol
        return formattedZero.replace(/\d|[.,\s]/g, '').trim();
    }, [formattedZero]);
    return symbol;
};
